<template>
<!--  <div style="height: 100%">-->
    <el-container style="height: 100%;">
      <!-- 左侧边栏-->
      <el-aside style="background-color: #232D32; text-align: left; width: auto">
        <el-menu background-color="#232D32" text-color="#ffffff" active-text-color="#539FFF"
                 :router=true :collapse="isCollapse" :unique-opened="true"
                 class="el-menu-vertical-demo" :default-active="$route.path">
          <template v-for="(item, i) in $router.options.routes" v-if="!item.hidden">
            <!-- 此处index 绑定值必须为字符串且不能重复 否则所有有二级菜单的都会同时打开同时关闭-->
            <el-submenu v-if="item.subMenu" :index="item.path" :key="i">
              <template slot="title">
                <i :class="item.icon"></i>
                <!--此处v-show暂时解决缩回时文字还会显示的问题-->
                <span slot="title" v-show="!isCollapse">{{item.name}}</span>
              </template>
              <el-menu-item :index="child.path" v-for="(child, i) in item.children" :key="i">
                <i :class="child.icon" aria-hidden="true"></i>
                <span slot="title">{{child.name}}</span>
              </el-menu-item>
            </el-submenu>

            <el-menu-item v-else :index="item.children[0].path" :key="i">
              <i :class="item.children[0].icon" aria-hidden="true"></i>
              <span slot="title">{{item.children[0].name}}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>
      <!--顶栏-->
      <el-container>
        <el-header class="flex">
          <div class="header-icon" @click="isCollapse = !isCollapse">
            <i class="header-icon-i fa fa-bars"></i>
          </div>
          <div class="flex">
            <form class="" style="margin-right: 20px;">
              <el-select v-model="appId" placeholder="请选择游戏" filterable @change="changeApp">
                <el-option v-for="item in appOptions" :key="item.id" :label="item.id + '-' + item.name" :value="item.id"></el-option>
              </el-select>
            </form>
<!--            <user-setting></user-setting>-->
            <div class="header-icon" @click="fedLogOut">
              <i class="header-icon-i fa fa-power-off"></i>
            </div>
          </div>
        </el-header>
        <!--主体内容-->
        <el-main style="margin: 0;padding: 10px;text-align: left">
          <router-view/>
        </el-main>
      </el-container>
</el-container>
<!--  </div>-->
</template>

<script>
import UserSetting from './UserSetting'
import p from '@/common/privilege'

export default {
  name: 'ContentHeader',
  components: { UserSetting },
  created () {
    this.$store.dispatch('GetApp').then(() => {
      this.appId = this.$store.getters.appId
      this.appOptions = this.$store.getters.app
      this.$store.dispatch('ChangeApp', this.appId).then(() => {
        this.appId = this.$store.getters.appId
        this.appOptions = this.$store.getters.app
      })
    })
  },
  data () {
    return {
      isCollapse: false,
      appId: this.$store.getters.appId,
      appOptions: this.$store.getters.app
    }
  },
  methods: {
    changeApp () {
      this.$store.dispatch('ChangeApp', this.appId).then(() => {
        this.appId = this.$store.getters.appId
      })
    },
    fedLogOut () {
      this.$confirm('确认退出吗？', '提示', {type: 'warning'}).then(() => {
        this.$store.dispatch('FedLogOut').then(() => {
          const redirectUri = encodeURIComponent(window.location.origin + '#/login')
          window.location.href = p.OAuthExitUrl + '?redirect_uri=' + redirectUri
        })
      }, _ => {})
    }
  }
}
</script>

<style scoped>
  .el-header {
    background-color: #4A8EBE; /*白色*/
    /*background-color: #353A4D;  !*黑色*!*/
    color: #ffffff;
    line-height: 60px;
    padding: 0;
  }
  .el-aside {
    color: #ffffff;
    background-color: #232D32;
    /*background-color: #2f3243; !*黑色*!*/
  }
  .el-menu {
    border: none;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center
  }
  .header-icon {
    height: 56px;
    width: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .header-icon-i {
    font-size: 18px;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Layout/index.vue